import { Head } from "@inertiajs/react"

type MarketingMetadataProps = {
  alternateUrls: {
    hr: string
    en: string
    x_default: string
  }
  canonicalUrl: string
  description: string
  locale: "hr" | "en"
  noindex: boolean
  socialImageUrl: string | null
  structuredData?: Record<string, unknown>
  title: string
}

export function MarketingMetadata({
  alternateUrls,
  canonicalUrl,
  description,
  locale,
  noindex,
  socialImageUrl,
  structuredData,
  title,
}: MarketingMetadataProps) {
  const fullTitle = `${title} | Zmile`

  return (
    <Head title={fullTitle}>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Zmile" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content={locale === "hr" ? "hr_HR" : "en_US"} />
      <meta property="og:locale:alternate" content={locale === "hr" ? "en_US" : "hr_HR"} />
      {socialImageUrl && <meta property="og:image" content={socialImageUrl} />}
      {socialImageUrl && <meta property="og:image:width" content="1200" />}
      {socialImageUrl && <meta property="og:image:height" content="630" />}
      {socialImageUrl && <meta property="og:image:alt" content={fullTitle} />}
      {socialImageUrl && <meta name="twitter:image" content={socialImageUrl} />}
      {socialImageUrl && <meta name="twitter:image:alt" content={fullTitle} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang="hr" href={alternateUrls.hr} />
      <link rel="alternate" hrefLang="en" href={alternateUrls.en} />
      <link rel="alternate" hrefLang="x-default" href={alternateUrls.x_default} />
      {structuredData && (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      )}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Head>
  )
}
